<template>
	<div style="display: flex; justify-content: space-evenly">
		<template v-if="isLoading2">
			<!--KD/LP 클레임 발생현황 -->
			<sf-card :title="getMessage_('QWCC001738')" class="p-0 border-0 bg-transparent">
				<doughnut-chart :height="280" ref="grpDoughnut" :chartData="datacollection2" :options="optionCollection2" />
			</sf-card>

			<!-- KD/LP 클레임 탑 현황 -->
			<sf-card :title="getMessage_('QWCC001737')" class="p-0 border-0 bg-transparent">
				<bar-chart :height="280" ref="grpBar" :chartData="datacollection3" :options="optionCollection3" />
			</sf-card>
		</template>
	</div>
</template>

<script>
import Chart from '@/qmsUtils/chartModule';
import { rootComputed } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@mqy/clma/PcPcm/store/helpers';
export default {
	components: {
		BarChart: Chart.BarChart,
		DoughnutChart: Chart.DoughnutChart
	},
	data() {
		return {};
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		datacollection2() {
			return {
				labels: this.doughnutLabel_,
				datasets: this.doughnutDataSet_
			};
		},
		datacollection3() {
			return {
				labels: this.stackedLabel3_,
				datasets: this.stackedDataSet3_
			};
		},
		optionCollection2() {
			return {
				responsive: true,
				maintainAspectRatio: false, // chart 높이 지정을 위해 필요
				plugins: {
					datalabels: {
						color: '#000', //데이터 값 표시 폰트 색상
						boxWidth: 8,
						padding: 10,
						usePointStyle: true,
						pointStyle: 'circle'
					}
				},
				legend: {
					display: false,
					position: 'bottom' //범례 위치: 아래
				}
			};
		},
		optionCollection3() {
			//추가
			return {
				responsive: true,
				maintainAspectRatio: false, // chart 높이 지정을 위해 필요
				plugins: {
					datalabels: {
						color: '#000', //데이터 값 표시 폰트 색상
						boxWidth: 8,
						padding: 10,
						usePointStyle: true,
						pointStyle: 'circle'
					}
				},
				legend: {
					display: false,
					position: 'bottom'
				},
				scales: {
					yAxes: [
						{
							ticks: {
								beginAtZero: true,
								suggestedMin: 50,
								suggestedMax: this.chartBcYMaxVal_
							}
						}
					]
				}
			};
		}
	},
	methods: {
		...serviceMethods
	}
};
</script>

<style></style>
